// @module CustomMatrixOption
define('CustomMatrixOption.View'
,	[
		'custommatrixoption.tpl'	
	,	'Backbone'
	,	'jQuery'
	,	'underscore'
    ]
, function (
		custommatrixoption_tpl	
	,	Backbone
	,	jQuery
	,	_
)
{
    'use strict';

	// @class CustomMatrixOption.View @extends Backbone.View
	return Backbone.View.extend({

		template: custommatrixoption_tpl

	,	title: 'Add Cut Link Value'

	,	initialize: function (options) {
			this.application = options.application;
			this.lines = options.lines || [];
			console.log("this.lines@@",this.lines)
			this.cartComponent = options.cartComponent;
		}

	,	events: {
			'click [data-action="update-items"]': 'updateItems'
		}


	,	updateItems: function(e){
			var $inputs = this.$('[name="custcol_web_cut_link"]')
			,	areAllInputsValid = true
			,	lineIDs = []
			,	lines = []
			,	self = this;
			
			$inputs.each(function(){				
				var value = this.value && this.value.trim()
				,	lineID = this.getAttribute('data-line-id')
				,	line = _.find(self.lines, {internalid: lineID});

				lineIDs.push(lineID);
				
				if(!!line && !!value){
					lines.push({
						quantity: line.quantity
					,	item: {
							internalid: line.item.internalid
						}
					,	options: [].concat(line.options || [], [{
							cartOptionId: 'custcol_web_cut_link'
						,	value: {internalid: value}
						}])
					});
				}
				areAllInputsValid = areAllInputsValid && !!value;
			});

			if(!areAllInputsValid){
				this.showError("Enter value for all items.");
			}
			else{
				this.hideError();
				var prom = jQuery.Deferred()
				,	addLineProm = this.cartComponent.addLines({lines: lines});
				
				this.disableElementsOnPromise(prom, '[data-action="update-items"]');
				
				addLineProm.then(function(){
					var proms = _.map(lineIDs, function(lineID){
						return self.cartComponent.removeLine({line_id: lineID});
					});
					jQuery.when.apply(jQuery, proms).then(function(){
						prom.resolve();
						self.application.getLayout().closeModal();
					});
				});
			}
		}

		//@method getContext @return CustomMatrixOption.View.Context
	,	getContext: function getContext()
		{
			//@class CustomMatrixOption.View.Context
			var linesToShow = []
			,	itemOptionCutLink;

			_.each(this.lines || [], function(line, index){
				var showCutLinkOption = line.item.extras.custitem_show_cut_link_on_pdp_page
				,	showCutLinkOptionCart = line.item.extras.custitem_show_cut_link_on_cart_page
				,	optionCutLink = _.find(line.options || [], {'cartOptionId': 'custcol_web_cut_link'});

				if((showCutLinkOption||showCutLinkOptionCart) && !optionCutLink){
					linesToShow.push(line);
				}
				if(index < 1){	//Looking for this item option only once, so using index as counter.
					itemOptionCutLink = _.find(line.item.extras.itemoptions_detail.fields || [], {'internalid': 'custcol_web_cut_link'});
				}
			});

			return {
				lines: linesToShow
			,	itemOptionLabel: itemOptionCutLink && itemOptionCutLink.label
			,	itemOptionFieldType: itemOptionCutLink && itemOptionCutLink.type
			,	itemOptionId: 'custcol_web_cut_link'
			};
		}
	});
});
